import { render, staticRenderFns } from "./paypal-form.vue?vue&type=template&id=58ea9b42&scoped=true&"
import script from "./paypal-form.vue?vue&type=script&lang=js&"
export * from "./paypal-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ea9b42",
  null
  
)

export default component.exports